import React from 'react';

import RampUnit from '../../utils/Playwire/RampUnit';
import Button from 'Components/Button';
import styles from './GameOverAd.scss';

const GameOverAd = ({ clickHandler, targeting }) => {
  return (
    <div className={'GameOverAd'}>
      <div className="GameOverAd__content">
        <RampUnit type="med_rect_btf" id="gameover" />
        <Button
          text="Close"
          customClass=" GameOverAd__button"
          buttonSize="hero"
          clickHandler={clickHandler}
        />
      </div>
    </div>
  );
};

export default GameOverAd;
